// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2pE2d","avatar":"style_avatar__DKknL","menuIcon":"style_menuIcon__2fmUR"};